import React from 'react';
import PropTypes from 'prop-types';
import { LocaleProvider } from '../context';
import { Compose } from './Compose';
/**
 * The topmost component of Merchant Portal which is made available for submodules.
 * From this, a module may access several global contexts; such as LocaleProvider, NotificationProvider, and more.
 *
 * Set prop `showDevTools` to use a GUI to manually manipulate the contexts.
 *
 * @component
 * @example
 * return (
 *   <MerchantPortalBase showDevTools>
 *     <div>
 *       <h3>Children</h3>
 *     </div>
 *   </MerchantPortalBase>
 * )
 */
const MerchantPortalBase = ({ children }) => (React.createElement(Compose, { components: [LocaleProvider] }, children));
MerchantPortalBase.propTypes = {
    children: PropTypes.node,
};
MerchantPortalBase.defaultProps = {
    children: null,
};
export default MerchantPortalBase;
